$(document).ready(function(){ 
      $('.product-form__label.available span.text').first().text();
      $('.product-form__label').on('click',function(){
                  let isColour = $(this).attr('data-option-name');
                  if(isColour == "Colour")
                  {
                         let varId = $(this).attr('data-variant-id');
                         let proId = $('input[name="product-id"]').val();
                         ajaxRequest(varId);

                  }
      })
      if($('input[name="product-id"]').val() > 0)
      {
            setTimeout(() => {
                  var vari_name =  $('.product-form__radio:checked').val();
                  var vid = $('.product-form__radio:checked').attr('data-variant-id');
                  ajaxRequest(vid);
            }, 500);
           
      }
       
      var $payment = $('.footer-block__list-payment.footer__column-item.footer__payment');
      var $newsletter = $('.footer-block__newsletter.newsletter__.text-left');
      if ($payment.length && $newsletter.length) {
            $newsletter.append($payment);
      } else {
            console.warn('⚠️ One of the elements was not found');
      }

  function ajaxRequest(vid){
    $.ajax({
          url: 'https://etd-app.package7.io/api/shopify/product/variant-qty',
          method: 'GET',
            data: {
                  vari_id: vid
            },
            dataType: 'json'
    })
    .done(function(response, status, xhr) {
          var vari_name =  $('.product-form__radio:checked').val();
          $('.available_sizes_title').html('<strong>Available sizes for:</strong> '+vari_name);
          $('.available_sizes').html('');
          Object.entries(response)
    .sort(function(a, b) {
        var aNum = parseFloat(a[0]);
        var bNum = parseFloat(b[0]);

        return aNum - bNum;
    })
    .forEach(function(item) {
        var sizeKey = item[0];
        var quantity = item[1];

        console.log(sizeKey, quantity);

        $('.available_sizes').append(
            '<li>' + sizeKey + ': ' + quantity + '</li>'
        );
    });
    })
    .fail(function(xhr, status, errorThrown) {
          console.error('Fail (Error)!', status, errorThrown);
    })
    .always(function(responseOrXhr, status, xhrOrErrorThrown) {
          console.log('Always (Complete).');
        // $('#loading-indicator').hide();
    });
  }
  
})